__turbopack_context__.v({
  "assessment-form__list": "-OxRLq_assessment-form__list",
});
